import LoginModal from '@/components/LoginModal';
import { useWishlist } from '@/context/WishlistContext';
import { toast } from 'sonner';

const GlobalLoginModal = () => {
  const { showLoginModal, closeLoginModal, handleLoginSuccess } = useWishlist();

  const onSuccess = () => {
    handleLoginSuccess();
    toast.success('Item added to your favorites!');
  };

  return (
    <LoginModal 
      isOpen={showLoginModal} 
      onClose={closeLoginModal} 
      onSuccess={onSuccess}
    />
  );
};

export default GlobalLoginModal;
